console.log('showpopup.js loaded');

function showPopup(input) {
    var popup = document.createElement('div');
    popup.id = 'popup';
    popup.className = 'table';
    doek.appendChild(popup);
    animatePopupIn(popup);
    createCloseButton(popup);

    var info = document.createElement('div');
    info.className = 'info';

    var img = document.createElement('img');
    img.src = './img/popup/' + input + '.jpg';
    img.alt = input;
    img.className = 'popup_img';
    popup.appendChild(img);

    // Stop de kant-en-klare HTML van Kirby direct in de popup (Showdown is niet meer nodig!)
    info.innerHTML = markdownInfo[input] || input;

    // Converteer de 'Reflectievragen' HTML-elementen naar de inklapbare knop
    formatReflectievragen(info);

    popup.appendChild(info);
    createCloseButton(popup);
};

function formatReflectievragen(container) {

    console.log('dit is m');

    
    // Zoek naar elementen die beginnen met Reflectievragen
    const elements = container.querySelectorAll('p, strong, h2, h3, h4');

    elements.forEach(el => {
        const cleanText = el.textContent.trim();

        if (cleanText.startsWith('Reflectievragen')) {
            // 1. Maak de uitklapknop
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'reflectievragen-btn';
            btn.innerText = 'Reflectievragen';

            // 2. Maak het container-element voor de uitklapbare vragen
            const uitklapper = document.createElement('div');
            uitklapper.className = 'uitklapper';

            // Haal 'Reflectievragen' af van het eerste element
            let contentHTML = el.innerHTML.replace(/^(\s*<[^>]+>)*\s*Reflectievragen\s*[-–:]?\s*/i, '');
            
            if (contentHTML.trim() !== '') {
                const p = document.createElement('p');
                p.innerHTML = contentHTML;
                uitklapper.appendChild(p);
            }

            // 3. Pak de opvolgende HTML-elementen (zoals de <ul> lijst met vragen) en stop ze IN de uitklapper
            let nextEl = el.nextElementSibling;
            while (nextEl) {
                if (['H1', 'H2', 'H3'].includes(nextEl.tagName)) break; // Stop als we bij een nieuw kopje komen
                
                const toMove = nextEl;
                nextEl = nextEl.nextElementSibling;
                uitklapper.appendChild(toMove);
            }

            // 4. Plaats de knop en uitklapper in het document en verwijder het oude element
            el.parentNode.insertBefore(btn, el);
            el.parentNode.insertBefore(uitklapper, el);
            el.remove();
        }
    });
}